import React, { useState, useEffect } from "react";
import { Alert, Result } from "antd";
import styled from "styled-components";
import MainWrapper from "../components/MainWrapper";
import TransactionInfoCard from "../components/TransactionInfoCard";
import SpinerIndicator from "../components/SpinerIndicator";
import WarningModal from "../components/WarningModal";
import { useDispatch, useSelector } from "react-redux";
import getVerifyManualTransaction, {
  getVerifyManualTransactionMyr,
} from "../redux/actions/getVerifyManualTransaction";
import { Navigate, useNavigate } from "react-router";
import { useParams, useLocation } from "react-router-dom";
import AlertMessageWrapper from "../components/AlertMessageWrapper";
import ButtonWrapper from "../components/ButtonWrapper";
import QrCardInfo from "./QrCardInfo";
import { Select } from "antd";
import AutoMethodTransactionInfoCard from "../components/AutoMethodTransactionInfoCard";
import PaymentMethodSelectCard from "../components/PaymentMethodSelectCard";
import SpinerIndicatorWhiteBg from "../components/SpinerIndicatorWhiteBg";
import MyrSuccessScreen from "../components/MyrSuccessScreen";
import {
  checkMyrCreatedTransaction,
  postMyrCreateTransaction,
} from "../redux/actions/postQrInitManual";

const { Option } = Select;

const MyrTransactionInfo = (props) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState("th");

  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  const { data: trnxCheckData, error: trnxCheckError } = useSelector(
    (state) => state.getQrManualCheckReducer
  );

  useEffect(() => {
    dispatch(getVerifyManualTransactionMyr(params.id, params?.method));
    let redirectionUrl = location.search?.split("=")[1];
    if (redirectionUrl !== undefined) {
      localStorage.setItem("redirectionUrl", redirectionUrl);
    }
  }, []);

  // ----------------CREATE THE TRANSACTION-------------
  useEffect(() => {
    if (verifyData) {
      let myrTransactionParams = {
        transactionId: verifyData.trxRef,
        type:
          verifyData?.payOptions?.includes("ob-script") &&
          params?.method == "myr"
            ? "ob-script"
            : verifyData?.payOptions?.includes("vietqr") &&
              params?.method == "vnd"
            ? "vietqr"
            : "fpx",
        amount: parseFloat(verifyData?.amount),
        sessionId: verifyData.sessionToken,
        userId: verifyData.merchantId,
      };

      dispatch(
        postMyrCreateTransaction(
          myrTransactionParams,
          navigate,
          params.id,
          params?.method
        )
      );
    }
  }, [verifyData]);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={error} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <MainWrapper>
        {
          isLoading || qrInitLoading ? (
            <SpinerIndicatorWhiteBg fontSize="15px" color="#000" />
          ) : (
            errorMessage()
          )
          // <MyrSuccessScreen fontSize="15px" color="#000" />
          // navigate(`/myr/check-transaction/${params.id}`)
        }
      </MainWrapper>
    </div>
  );
};

export default MyrTransactionInfo;
